<template>
  <div id="header-section">
    <div class="profile-container">
        <img src="../assets/profile.png">
        <p>{{ profile.name }}</p>
    </div>
    <div class="rewards-container">
        <img id="coin" src="../assets/coin@2x.png">
        <div>{{ profile.totalcoins }}</div>
        <img id="gem" src="../assets/gem@2x.png">
        <div>{{ profile.totalgems }}</div>
    </div>
  </div>
</template>

<script>
  export default {
  name: 'header-section',
  props: {
      profile: Object
  }
}
</script>

<style scoped>
#header-section{
    position: relative;
    padding: 12px 0 40px 0;
    z-index:99;
}
.profile-container{
    position: fixed;
    left: 0;
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
}
.profile-container img{
    display:inline-block;
    vertical-align: middle;
    margin: 0 0 0 24px;
    width: 32px; height: 32px; 
    border-radius:50%;
}
.profile-container p{
    display: inline-block;
    line-height: 20px;
    padding: 0 0 0 12px;
}
.rewards-container{
    position: fixed;
    display: block;
    margin-top: 6px;
    right: 0;
    background: #ffffff;
    height: 32px;
    width: 150px;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    box-shadow: 0 2px 10px rgba(0,0,0,.32);
    text-align: left;
    font-size: 16px;
    font-weight: 900;
}
.rewards-container div, .rewards-container img{
    display: inline-block;
    vertical-align: middle;
    margin-top: 7px;
    margin-left: 12px;
}
.rewards-container #coin{
    height: 18px;
    margin-left: 16px;
}
.rewards-container #gem{
    height: 16px;
    margin-left: 16px;
}
</style>